import type { PartSvgProps } from './types'

export default function HandguardSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 200,
  height = 80
}: PartSvgProps) {
  // Slot positions: 5 evenly-spaced M-LOK slots top + bottom
  const slotXPositions = [30, 60, 90, 120, 150]

  return (
    <svg viewBox="0 0 200 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main tube — slight taper at both ends */}
      <path d="M 8 28 L 16 22 L 184 22 L 192 28 L 192 52 L 184 58 L 16 58 L 8 52 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Top M-LOK slots */}
      {slotXPositions.map((x) => (
        <rect key={`top-${x}`} x={x} y={24} width={14} height={5} rx="1"
              fill="none" stroke={accent} strokeWidth="1.2" />
      ))}
      {/* Bottom M-LOK slots */}
      {slotXPositions.map((x) => (
        <rect key={`bot-${x}`} x={x} y={51} width={14} height={5} rx="1"
              fill="none" stroke={accent} strokeWidth="1.2" />
      ))}
      {/* Center bore line */}
      <line x1="8" y1="40" x2="192" y2="40"
            stroke={stroke} strokeWidth="0.8" strokeDasharray="6 4" />
    </svg>
  )
}
